export default __webpack_public_path__ + "static/media/mini_pink.1a2c544c.svg";